import { FooterContainer } from "@/components/commons/FooterContainer";
import { Button } from "@/components/elements/Button";
import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { TopPage } from "@/components/elements/TopPage";
import { MatchLocationInfo } from "@/features/match/components/match-info/MatchLocationInfo";
import { MatchBasicInfo } from "@/features/match/components/match-info/MatchBasicInfo";
import { MatchContractInfo } from "@/features/match/components/match-info/MatchContractInfo";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { Stack, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MatchJobIntroductionManagerInfo } from "@/features/match/components/match-info/MatchJobIntroductionManagerInfo";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { IconEditor } from "@/assets/icons";
import { MatchCustomSystemInfo } from "@/features/match/components/match-info/MatchCustomSystemInfo";

type TMatchFormProps = {
  previousValues?: Partial<TMatchInfo>;
};

export const MatchDetail: FCC<TMatchFormProps> = ({ previousValues }) => {
  const navigate = useNavigate();

  return (
    <Stack gap={1}>
      <TopPage title="紹介会社情報" enablePageBack={false} />

      <Grid
        container
        sx={{
          marginTop: 4,
        }}
      >
        <Grid item xs={12}>
          <MenuNavigate
            contents={[
              { title: "基本情報", content: <MatchBasicInfo defaultValues={previousValues ?? {}}></MatchBasicInfo> },
              {
                title: "職業紹介責任者情報",
                content: <MatchJobIntroductionManagerInfo defaultValues={previousValues ?? {}}></MatchJobIntroductionManagerInfo>,
              },
              { title: "所在地", content: <MatchLocationInfo defaultValues={previousValues ?? {}}></MatchLocationInfo> },
              { title: "システムカスタマイズ", content: <MatchCustomSystemInfo defaultValues={previousValues ?? {}} /> },
              { title: "契約情報", content: <MatchContractInfo defaultValues={previousValues ?? {}} /> },
            ]}
            contentWidth="900px"
            contentAffix={
              <FooterContainer>
                <Stack gap={1} direction="row" justifyContent="flex-end" alignItems="center">
                  <Button variant="outline" size="sm" onClick={() => navigate(AppRoutes.matchEdit)} startIcon={<IconEditor />}>
                    編集
                  </Button>
                </Stack>
              </FooterContainer>
            }
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
